export default __webpack_public_path__ + "1.17.16/static/media/libreLinkUp-small.06b9e023.svg";